import React, { useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import queryString from "query-string";
import { addParamUrl, useScript } from "../../../../utils";
import { HTTP_API } from "../../../../api/HttpClient";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import moment from "moment";
import loadImage from "blueimp-load-image";
import Header from "../../layout/Header";
import LoadingOverlay from "../../common/LoadingOverlay";
import { Footer } from "../../layout/Footer";
import { ExplanationMypage } from "../../layout/ExplanationMypage";
import ReceiptService from "../../../../api/services/GochiKid/ReceiptService";
import TwoocaService from "../../../../api/services/TwoocaService";
import { GochiKidPreviewImageReceiptModal } from "./GochiKidPreviewImageReceiptModal";
import { GochiKidReceiptResultModal } from "./GochiKidReceiptResultModal";
import { GochiKidReceiptConfirmModal } from "./GochiKidReceiptConfirmModal";
import { GochiKidReceiptSuccessModal } from "./GochiKidReceiptSuccessModal";
import { GochiKidErrorUploadReceiptModal } from "./GochiKidErrorUploadReceiptModal";
import { TwoocaReceiptDetailModal } from "./TwoocaReceiptDetailModal";

export function GochiKidTwoocaBillHistory(props) {
  useScript("/assets/js/app.js");

  const paramsUrl = queryString.parse(window.location.search);
  const isSite = paramsUrl.isSite;
  const isSiteParam = isSite ? { name: "isSite", value: isSite } : {};
  const { gochiKidUseId } = useParams();
  const NO_IMAGE_MENU = require("../../../../assets/img/icons/square_blank.png");
  const ICON_WARNING = require("../../../../assets/img/icons/icon-warning-button-go-shop.png");

  const uploadReceiptForStatus = {
    EDIT: "EDIT",
    REUPLOAD: "REUPLOAD",
  };

  const [gochiKidUseDetail, setGochiKidUseDetail] = useState(null);
  const [listReceiptImageGochiKid, setListReceiptImageGochiKid] = useState([]);
  const [policy, setPolicy] = useState(false);
  const [imageReceiptFile, setImageReceiptFile] = useState();
  const [imageReceiptFileUrl, setImageReceiptFileUrl] = useState();
  const [showReceiptDetailModal, setShowReceiptDetailModal] = useState();
  const [showPreviewImgReceiptModal, setShowPreviewImgReceiptModal] =
    useState(false);
  const [showReceiptResultModal, setShowReceiptResultModal] = useState(false);
  const [showReceiptConfirmModal, setShowReceiptConfirmModal] = useState(false);
  const [showReceiptSuccessModal, setShowReceiptSuccessModal] = useState(false);
  const [showErrorReceiptModal, setShowErrorReceiptModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isErrorReceipt, setIsErrorReceipt] = useState(false);
  const [messageErrorReceiptModal, setMessageErrorReceiptModal] = useState("");
  const [messageErrorModal, setMessageErrorModal] = useState("");
  const [titleReceiptSuccessModal, setTitleReceiptSuccessModal] = useState("");
  const [messageReceiptSuccessModal, setMessageReceiptSuccessModal] =
    useState("");
  const [uploadReceiptFor, setUploadReceiptFor] = useState("");
  const [receiptChoose, setReceiptChoose] = useState(null);
  const [itemReceiptArr, setItemReceiptArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [receiptImageBase64, setReceiptImageBase64] = useState(null);
  const [receiptOldId, setReceiptOldId] = useState(null);

  useEffect(() => {
    if (isSite) {
      document.body.className = "mypage " + isSite;
      window.scrollTo(0, 0);
    } else {
      document.body.className = "mypage";
      window.scrollTo(0, 0);
    }

    getGochiKidUseDetail();
  }, []);

  function getTitle() {
    return "マイページ｜「ごちめし」飲食店のメニューをお食事券でプレゼントできるサービス";
  }

  function getMetaDescription() {
    return "マイページです。「ごちめし」は飲食店のメニューをお食事券でプレゼント・ギフトできるサービスです。誕生日や記念日など感謝や労いのタイミングに、メール・LINE・携帯電話のメッセージ機能ですぐにプレゼントを贈ることができます。";
  }

  async function getGochiKidUseDetail() {
    setLoading(true);
    const response = await TwoocaService.getGochiKidUseDetail(gochiKidUseId);

    if (response.status === HTTP_API.SUCCESS) {
      setGochiKidUseDetail(response.data);

      if (response.data && response.data.receipt.length > 0) {
        let listReceiptImage = [];

        response.data.receipt.forEach(async (item, index) => {
          if (item) {
            listReceiptImage.push({
              image: item?.receiptImage,
              imageBase64: null,
            });

            convertImageToBase64(item?.receiptImage, function (dataUrl) {
              listReceiptImage[index].imageBase64 = dataUrl;
            });
          } else {
            listReceiptImage.push(null);
          }
        });

        setListReceiptImageGochiKid(listReceiptImage);
        console.log(listReceiptImage);
      } else {
        setListReceiptImageGochiKid([]);
      }
    } else if (response.status === HTTP_API.ERROR_NOTFOUND) {
      window.location.href = "/404";
    } else {
      alert("エラーが発生しました。");
    }

    setLoading(false);
  }

  function convertImageToBase64(url, callback) {
    if (!url) {
      return null;
    }

    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  const onChangeImgUpload = async (
    event,
    gochiKidUseId,
    uploadFor,
    oldReceiptId
  ) => {
    console.log("onChangeImgUpload", event);

    if (uploadFor) {
      setUploadReceiptFor(uploadFor);
    }

    if (oldReceiptId) {
      setReceiptOldId(oldReceiptId);
    }

    const file = event.target.files[0];
    // const image = await resizeFile(file);
    let fileName = file.name;
    const re = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i;
    if (!re.exec(fileName)) {
      handleOpenUploadReceiptErrorModal(
        "アップロード可能なファイル形式はJPEG、JPG、PNGのみです。正しい形式のレシート画像を再選択してください。"
      );
      return;
    }

    var ext = fileName.split(".").pop();
    fileName = "receipt" + gochiKidUseId + "-" + Date.now() + "." + ext;
    const { resizeImageFile } = await resizeImage(file);
    const image = new File([resizeImageFile], fileName, { type: file.type });
    setImageReceiptFile(image);
    setImageReceiptFileUrl(URL.createObjectURL(image));
    setShowPreviewImgReceiptModal(true);
  };

  const resizeImage = (image) => {
    return new Promise((resolve, reject) => {
      loadImage.parseMetaData(image, (data) => {
        const options = {
          maxWidth: process.env.REACT_APP_RESIZE_MAX_WIDTH,
          canvas: true,
        };

        if (data.exif) {
          options.orientation = data.exif.get("Orientation");
        }

        let fileName = image.name;
        loadImage(
          image,
          (canvas) => {
            try {
              const imageUri = canvas.toDataURL("image/*");

              const resizeImageFile = toBlob(imageUri, fileName, reject);
              resolve({
                resizeImageFile,
              });
            } catch (error) {
              handleOpenUploadReceiptErrorModal(
                "アップロード可能なファイル形式はJPEG、JPG、PNGのみです。正しい形式のレシート画像を再選択してください。"
              );
              return;
            }
          },
          options
        );
      });
    });
  };

  const toBlob = (base64, fileName, reject) => {
    const bin = atob(base64.replace(/^.*,/, ""));
    const buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i += 1) {
      buffer[i] = bin.charCodeAt(i);
    }

    try {
      const blob = new Blob([buffer.buffer], {
        type: "image/*",
      });
      blob.name = fileName;
      return blob;
    } catch (e) {
      reject();
      return false;
    }
  };

  const handleClosePreviewImageModal = () => {
    setImageReceiptFile("");
    setImageReceiptFileUrl("");
    setShowPreviewImgReceiptModal(false);
  };

  const handleUploadReceipt = async () => {
    setLoading(true);
    setReceiptImageBase64(null);

    try {
      const response = await TwoocaService.uploadGochiKidReceipt(
        gochiKidUseId,
        imageReceiptFile,
        receiptOldId
      );

      if (response.status === HTTP_API.SUCCESS) {
        setReceiptChoose(response.data);
        setItemReceiptArr(
          response.data.ocrDetails ? response.data.ocrDetails : []
        );
        setReceiptImageBase64({
          image: imageReceiptFileUrl,
          imageBase64: null,
        });
        setShowReceiptResultModal(true);
        setShowPreviewImgReceiptModal(false);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      const errorInfo = error.response?.data?.errorInfo;

      if (
        errorInfo?.code === "exception.errors.ocr.payment.date.error" ||
        errorInfo?.code === "exception.errors.ocr.shop.not.found" ||
        errorInfo?.code === "exception.errors.twooca.receipt.duplicate"
      ) {
        handleOpenUploadReceiptErrorModal(
          "利用履歴の情報とレシートの内容が一致しません。利用履歴に対応するレシート画像を再選択してください。"
        );
      } else if (
        errorInfo?.code === "exception.errors.gochikid.ocr.validation.failure"
      ) {
        handleOpenUploadReceiptErrorModal(
          <>
            レシート画像の読み取りができませんでした。以下の内容をご確認いただき、レシート画像を再選択してください。
            <br />
            <br />
            【ご確認事項】
            <br />
            1.レシート全体が鮮明に写っているか（文字がはっきり読み取れる状態）。
            <br />
            2.レシートが破損していないか、必要な情報（日付、店舗名、品目、税種別など）が欠けていないか。
            <br />
            3.ネットワーク接続が安定しているか（通信エラーの可能性がある場合）。
            <br />
            <br />
            上記を確認後、問題が解消しない場合は下記サイトからお問い合わせください。
            <br />
            <a
              href="https://support.gigi.tokyo/contact/kodomogochimeshi-receipt/"
              target="_blank"
            >
              https://support.gigi.tokyo/contact/kodomogochimeshi-receipt/
            </a>
          </>
        );
      } else {
        handleOpenUploadReceiptErrorModal(
          <>
            内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
            <br />
            <a
              href="https://support.gigi.tokyo/contact/for-user/"
              target="_blank"
            >
              https://support.gigi.tokyo/contact/for-user/
            </a>
          </>
        );
      }

      setLoading(false);
    }
  };

  const handleCloseGochiKidResultModal = () => {
    setShowReceiptResultModal(false);

    if (uploadReceiptFor !== uploadReceiptForStatus.EDIT) {
      setShowPreviewImgReceiptModal(true);
    }
  };

  const handleOpenUploadReceiptErrorModal = (message) => {
    setMessageErrorReceiptModal(message);
    setShowPreviewImgReceiptModal(false);
    setShowErrorReceiptModal(true);
  };

  const handleCloseErrorReceiptModal = () => {
    setMessageErrorReceiptModal("");
    setShowErrorReceiptModal(false);
  };

  const handleOpenGochiKidReceiptConfirmModal = () => {
    setShowReceiptConfirmModal(true);
    setShowReceiptResultModal(false);
  };

  const handleCloseGochiKidReceiptConfirmModal = () => {
    setShowReceiptConfirmModal(false);
    setShowReceiptResultModal(true);
  };

  const handleSubmitGochiKidReceipt = async () => {
    if (uploadReceiptFor === uploadReceiptForStatus.EDIT) {
      const params = {
        gochiKidReceiptId: receiptChoose.id,
        receiptDetails: [],
      };
      let listItemReceipt = [];

      itemReceiptArr.forEach((item) => {
        const tempItem = {
          gochiKidReceiptDetailId: item.id,
          amount: item.amount,
          taxRate: item.taxRate,
        };
        listItemReceipt.push(tempItem);
      });
      params.receiptDetails = listItemReceipt;
      setLoading(true);

      try {
        const response = await ReceiptService.updateGochiKidReceipt(params);

        if (response.status === HTTP_API.SUCCESS) {
          setShowReceiptSuccessModal(true);
          setTitleReceiptSuccessModal("レシート登録 確認");
          setMessageReceiptSuccessModal("登録確定しました！");
          setShowReceiptConfirmModal(false);
        } else {
          setShowReceiptConfirmModal(false);
          setShowErrorModal(true);
          setIsErrorReceipt(true);
          setMessageErrorModal(
            <>
              内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
              <br />
              <a
                href="https://support.gigi.tokyo/contact/for-user/"
                target="_blank"
              >
                https://support.gigi.tokyo/contact/for-user/
              </a>
            </>
          );
        }
      } catch (e) {
        console.log("Submit receipt fail", e);
        setShowReceiptConfirmModal(false);
        setShowErrorModal(true);
        setIsErrorReceipt(true);
        setMessageErrorModal(
          <>
            内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
            <br />
            <a
              href="https://support.gigi.tokyo/contact/for-user/"
              target="_blank"
            >
              https://support.gigi.tokyo/contact/for-user/
            </a>
          </>
        );
      }

      setLoading(false);
    } else {
      const params = {
        gochiKidOcrId: receiptChoose.id,
        ocrDetails: [],
        oldReceiptId: receiptOldId,
      };
      let listItemReceipt = [];

      itemReceiptArr.forEach((item) => {
        const tempItem = {
          gochiKidOcrDetailId: item.id,
          amount: item.amount,
          taxRate: item.taxRate,
        };
        listItemReceipt.push(tempItem);
      });
      params.ocrDetails = listItemReceipt;
      setLoading(true);

      try {
        const response = await TwoocaService.submitGochiKidReceipt(params);

        if (response.status === HTTP_API.SUCCESS) {
          setShowReceiptSuccessModal(true);
          setTitleReceiptSuccessModal("レシート登録 確認");
          setMessageReceiptSuccessModal("登録確定しました！");
          setShowReceiptConfirmModal(false);
        } else {
          setShowReceiptConfirmModal(false);
          setShowErrorModal(true);
          setIsErrorReceipt(true);
          setMessageErrorModal(
            <>
              内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
              <br />
              <a
                href="https://support.gigi.tokyo/contact/for-user/"
                target="_blank"
              >
                https://support.gigi.tokyo/contact/for-user/
              </a>
            </>
          );
        }
      } catch (e) {
        console.log("Submit receipt fail", e);
        setShowReceiptConfirmModal(false);
        setShowErrorModal(true);
        setIsErrorReceipt(true);
        setMessageErrorModal(
          <>
            内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
            <br />
            <a
              href="https://support.gigi.tokyo/contact/for-user/"
              target="_blank"
            >
              https://support.gigi.tokyo/contact/for-user/
            </a>
          </>
        );
      }

      setLoading(false);
    }
  };

  const handleCloseReceiptSuccessModal = async () => {
    setShowReceiptSuccessModal(false);
    setReceiptChoose(null);
    setItemReceiptArr([]);
    setLoading(true);
    await getGochiKidUseDetail();
    setLoading(false);
  };

  const handleCheckReceiptByAI = async (receiptId) => {
    setLoading(true);
    const params = {
      gochiKidReceiptId: receiptId,
    };

    try {
      const response = await ReceiptService.checkReceiptByAi(params);

      if (response.status === HTTP_API.SUCCESS) {
        setShowReceiptSuccessModal(true);
        setTitleReceiptSuccessModal("品目再申請 完了");
        setMessageReceiptSuccessModal(
          <>
            再申請を完了しました！
            <br />
            申請結果確定までしばらくお待ちください。
          </>
        );
      } else {
        setShowErrorModal(true);
        setIsErrorReceipt(false);
        setMessageErrorModal(
          <>
            内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
            <br />
            <a
              href="https://support.gigi.tokyo/contact/for-user/"
              target="_blank"
            >
              https://support.gigi.tokyo/contact/for-user/
            </a>
          </>
        );
      }
    } catch (e) {
      console.log(e);
      setShowErrorModal(true);
      setIsErrorReceipt(false);
      setMessageErrorModal(
        <>
          内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
          <br />
          <a
            href="https://support.gigi.tokyo/contact/for-user/"
            target="_blank"
          >
            https://support.gigi.tokyo/contact/for-user/
          </a>
        </>
      );
    }
    setLoading(false);
  };

  const handleCheckReceiptByAdmin = async (receiptId) => {
    setLoading(true);
    const params = {
      gochiKidReceiptId: receiptId,
    };

    try {
      const response = await ReceiptService.checkReceiptByAdmin(params);

      if (response.status === HTTP_API.SUCCESS) {
        setShowReceiptSuccessModal(true);
        setTitleReceiptSuccessModal("再々申請 完了");
        setMessageReceiptSuccessModal(
          <>
            再々申請を完了しました。
            <br />
            レシート登録内容を確認しますので、しばらくお待ちください。
          </>
        );
      } else {
        setShowErrorModal(true);
        setIsErrorReceipt(false);
        setMessageErrorModal(
          <>
            内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
            <br />
            <a
              href="https://support.gigi.tokyo/contact/for-user/"
              target="_blank"
            >
              https://support.gigi.tokyo/contact/for-user/
            </a>
          </>
        );
      }
    } catch (e) {
      console.log(e);
      setShowErrorModal(true);
      setIsErrorReceipt(false);
      setMessageErrorModal(
        <>
          内部システムでエラーが発生しました。お手数ですが、下記サイトからお問い合わせください。
          <br />
          <a
            href="https://support.gigi.tokyo/contact/for-user/"
            target="_blank"
          >
            https://support.gigi.tokyo/contact/for-user/
          </a>
        </>
      );
    }

    setLoading(false);
  };

  const handleEditReceipt = (receipt, index) => {
    setReceiptImageBase64(listReceiptImageGochiKid[index]);
    setReceiptChoose(receipt);
    setItemReceiptArr(receipt.receiptDetails ? receipt.receiptDetails : []);
    setUploadReceiptFor(uploadReceiptForStatus.EDIT);
    setShowReceiptResultModal(true);
  };

  const handleCloseErrorModal = () => {
    setIsErrorReceipt(false);
    setShowErrorModal(false);

    if (isErrorReceipt) {
      setShowReceiptResultModal(true);
    }
  };

  const handleShowReceiptDetail = (receipt, index) => {
    setReceiptImageBase64(listReceiptImageGochiKid[index]);
    setReceiptChoose(receipt);
    setShowReceiptDetailModal(true);
  };

  return (
    <>
      <MetaTags>
        <title>
          マイページ｜「ごちめし」飲食店のメニューをお食事券でプレゼントできるサービス
        </title>
        <meta name="keywords" content={getTitle()} />
        <meta name="description" content="" />
        <meta name="twitter:card swiper-slide" content="summary_large_image" />
        <meta name="twitter:title" content={getTitle()} />
        <meta name="twitter:description" content={getMetaDescription()} />
        <meta
          name="twitter:image"
          content={window.location.origin + "/assets/img/common/ogp.png"}
        />
        <meta name="twitter:site" content="@gochi_meshi" />
        <meta name="twitter:creator" content="@gochi_meshi" />
        <meta name="twitter:image:width" content="300" />
        <meta name="twitter:image:height" content="300" />
        <meta property="og:site_name" content={getTitle()} />
        <meta property="og:title" content={getTitle()} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta
          property="og:image"
          content={window.location.origin + "/assets/img/common/ogp.png"}
        />
        <meta property="og:description" content={getMetaDescription()} />
      </MetaTags>

      <Header hideButtonOnHeader={false} />

      <main>
        <div className="breadcrumb">
          <div className="container">
            <ol className="breadcrumb-list">
              <li>
                <a href={addParamUrl("/mypage", [isSiteParam])}>
                  GOCHIマイページ
                </a>
              </li>
              <li>
                <a href={addParamUrl("/mypage/kodomo_use", [isSiteParam])}>
                  こどもごちめし食堂利用
                </a>
              </li>
              <li>
                <span>レシート登録履歴</span>
              </li>
            </ol>
          </div>
        </div>

        <div className="container">
          <div className="twooca-bill-history ">
            <div className="gochi-kid-use-digest">
              <div className="gochi-kid-use-thumbnail">
                <div className="thumbnail">
                  <img
                    src={
                      gochiKidUseDetail?.menuImage
                        ? gochiKidUseDetail.menuImage
                        : NO_IMAGE_MENU
                    }
                    alt="menu image"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="shop-header-group">
                <div className="shop-header">
                  <div className="shop-name">{gochiKidUseDetail?.shopName}</div>
                  <div className="menu-name">{gochiKidUseDetail?.menuName}</div>
                </div>
                <hr />
                <div className="price-area">
                  <div>
                    <div>
                      <span>利用人数: </span>
                      <span className="num">
                        {gochiKidUseDetail?.userKidNumUse}
                      </span>
                      <span className="unit">人</span>
                    </div>
                    <div>
                      <span>合計金額: </span>
                      <span className="num">
                        {gochiKidUseDetail?.usedAmount?.toLocaleString()}
                      </span>
                      <span className="unit">円</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="twooca-summary-container">
              <div className="twooca-summary">
                <div>
                  <div className="title">レシート登録金額</div>
                  <div>
                    <span className="text">
                      {gochiKidUseDetail?.twoocaReceiptUseAmount?.toLocaleString()}
                    </span>
                    <span className="yen">円</span>
                  </div>
                </div>
                <div className="seperate">/</div>
                <div>
                  <div className="title">チャージ額</div>
                  <div>
                    <span className="text">
                      {gochiKidUseDetail?.twoocaChargeAmount?.toLocaleString()}
                    </span>
                    <span className="yen">円</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="title-history">※最新順</div>

            <div className="list-menu-used-gochi-kid">
              <div className="gochi-gochi-used-list">
                <div className="gochi-kid-used-box">
                  {gochiKidUseDetail?.receipt?.length > 0 ? (
                    gochiKidUseDetail?.receipt?.map((receipt, index) => {
                      let elementReceiptStatus;
                      let elementReceiptStatusNote;

                      if (receipt.status === 1) {
                        elementReceiptStatus = <span>登録・承認済み</span>;
                      } else if (receipt.status === 2) {
                        elementReceiptStatus = (
                          <span className="text-red">登録済・承認保留</span>
                        );
                      } else if (receipt.status === 3) {
                        elementReceiptStatus = (
                          <span className="text-yallow">登録済・承認待ち</span>
                        );
                        elementReceiptStatusNote = (
                          <div className="btn-gochi-kid-use receipt-note">
                            <div>
                              <i className="icon-receipt-note" />
                            </div>
                            ただいまレシート登録内容を確認しておりますので、しばらくお待ちください。
                          </div>
                        );
                      } else if (receipt.status === 4) {
                        elementReceiptStatus = (
                          <span className="text-yallow">登録済・非承認</span>
                        );
                        elementReceiptStatusNote = (
                          <div className="receipt-note receipt-button-note">
                            <div>
                              <i className="icon-error-receipt icon" />
                            </div>
                            <div className="color-EC4A56">
                              「こどもごちめし」はお子さまの飲食費を支援するサービスで、皆様のご協力で運営されています。
                              <br />
                              不正利用が確認されたため、サービスのご利用を継続することができなくなりました。
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div
                          className="gochi-kid-item receipt-item"
                          key={`receipt-${receipt.id}`}
                        >
                          <div className="gochi-kid-support-item">
                            <div className="receipt-digest">
                              <div className="receipt-image-box">
                                <img
                                  src={receipt.receiptImage}
                                  alt="receipt image"
                                  className="receipt-image"
                                  loading="lazy"
                                />
                                {receipt.shopFoodFlag === 0 && (
                                  <img
                                    src={ICON_WARNING}
                                    width={25.5}
                                    height={22}
                                    className="icon-warning"
                                  />
                                )}
                              </div>

                              <div className="receipt-info">
                                <div className="receipt-date">
                                  {moment(receipt.createdAt).format(
                                    "YYYY/MM/DD  HH:mm"
                                  )}
                                </div>
                                <div className="receipt-info-row">
                                  <span className="title">金額</span>
                                  <span className="price">
                                    {receipt.amount.toLocaleString()}
                                  </span>
                                  <span className="yen">円</span>
                                </div>
                                <div className="receipt-info-row">
                                  <span className="title">登録状況</span>
                                  <span className="status">
                                    {elementReceiptStatus}
                                  </span>
                                </div>
                                <div className="receipt-info-row">
                                  <div
                                    onClick={() =>
                                      handleShowReceiptDetail(receipt, index)
                                    }
                                    className="receipt-detail"
                                  >
                                    レシート詳細を確認する
                                  </div>
                                </div>
                              </div>
                            </div>

                            {receipt.status !== 1 && (
                              <div className="receipt-action">
                                {receipt.status === 2 ? (
                                  <>
                                    <div className="warning-receipt-box receipt-note">
                                      <div>
                                        <i className="icon-warning-receipt icon" />
                                      </div>
                                      <div>
                                        品目にお子さまの飲食品以外（日用品や雑貨など）が検知されたため、承認できませんでした。
                                        <br />
                                        （承認されるまでこどもごちめしが利用できません）
                                        <br />
                                        <br />
                                        品目編集が必要な場合は「品目編集後に再申請」ボタンよりお子さまの飲食品以外の品目を削除して再申請してください。
                                        <br />
                                        <br />
                                        既に飲食品のみを登録している場合（判定が誤っている場合）は「現在の品目で再申請」ボタンを押下してください。
                                      </div>
                                    </div>

                                    <div className="check-receipt-btn-box btn-gochi-kid-use">
                                      <button
                                        className="btn btn-rect btn-sm btn-edit-receipt"
                                        type="button"
                                        onClick={() =>
                                          handleEditReceipt(receipt, index)
                                        }
                                      >
                                        品目編集後に再申請
                                      </button>
                                      <button
                                        className={
                                          "btn btn-rect btn-sm btn-ai-check-receipt"
                                        }
                                        onClick={() =>
                                          handleCheckReceiptByAI(receipt.id)
                                        }
                                      >
                                        現在の品目で再申請
                                      </button>
                                    </div>

                                    <div className="admin-check-receipt-box">
                                      <div className="receipt-note receipt-button-note receipt-box">
                                        <div>
                                          <i className="icon-error-receipt icon" />
                                        </div>
                                        <div>
                                          上部に配置されている2つのボタンからお子さまの飲食品を再申請しているにもかかわらず、お子さまの飲食品以外だと2回判定された場合は、大変お手数をおかけいたしますが、下記の再々申請ボタンよりご連絡くださいますようお願い申し上げます。
                                          <p className="text-red">
                                            なお、この再々申請ボタンを使用した申請で、お子さまの飲食品以外の申請が確認された場合、サービスのご利用を継続いただけなくなりますのでご了承ください。
                                          </p>
                                        </div>
                                      </div>
                                      <div className="btn-admin-check-receipt">
                                        <button
                                          onClick={() =>
                                            handleCheckReceiptByAdmin(
                                              receipt.id
                                            )
                                          }
                                        >
                                          再々申請する
                                        </button>
                                      </div>
                                    </div>

                                    <div className="re-up-receipt-box">
                                      <div className="receipt-note receipt-button-note">
                                        <div>
                                          <i className="icon-error-receipt icon" />
                                        </div>
                                        <div>
                                          レシート登録を誤った場合、
                                          <span className="text-red">
                                            1アカウントにつき1回限り再登録を承ります。
                                          </span>
                                          <br />
                                          再登録するレシートは、お子さまの飲食品のみが記載されていれば、利用履歴の日付や店舗名と異なっていても問題ありません。
                                          <br />
                                          「こどもごちめし」はお子さまの飲食費を支援するサービスで、皆様のご協力で運営されています。
                                          <span className="text-red">
                                            次回以降の再登録はお受けできず、サービスのご利用を継続いただけなくなりますのでご了承ください。
                                          </span>
                                        </div>
                                      </div>

                                      {gochiKidUseDetail.gochiKidRetryUploadReceipt ===
                                      0 ? (
                                        <>
                                          <div className="checkbox-container">
                                            <div className="field field-checkbox policy-text-box">
                                              <label>
                                                <input
                                                  className="before-icon"
                                                  type="checkbox"
                                                  checked={policy}
                                                  onChange={(e) => {
                                                    setPolicy(e.target.checked);
                                                  }}
                                                />
                                                <i className="icon" />
                                              </label>
                                              <div className="policy-text-description">
                                                上記注意事項に同意する
                                              </div>
                                            </div>
                                          </div>
                                          <div className="btn-gochi-kid-use">
                                            <label
                                              className={`btn btn-rect btn-sm btn-gochi-kid-receipt ${
                                                !policy
                                                  ? "btn-disable-opactity"
                                                  : ""
                                              }`}
                                              htmlFor={`img-input-${index}`}
                                            >
                                              <input
                                                name="img-input"
                                                id={`img-input-${index}`}
                                                className="input-gochi-kid-receipt"
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => {
                                                  onChangeImgUpload(
                                                    e,
                                                    gochiKidUseId,
                                                    uploadReceiptForStatus.REUPLOAD,
                                                    receipt.id
                                                  );
                                                  e.target.value = null;
                                                }}
                                                disabled={!policy}
                                              />
                                              レシート再登録（1回限り）
                                            </label>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="gochi-kid-re-upload-note">
                                          以前に1回限りのレシート再登録を対応済みです。
                                        </div>
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  elementReceiptStatusNote
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="mt-16px">
                      現在、登録済みのレシートがありません。
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ExplanationMypage />
      </main>

      <Footer />

      <LoadingOverlay loading={loading} />

      {showPreviewImgReceiptModal && (
        <GochiKidPreviewImageReceiptModal
          showing={showPreviewImgReceiptModal}
          imageReceiptFileUrl={imageReceiptFileUrl}
          onClose={handleClosePreviewImageModal}
          onSubmit={handleUploadReceipt}
          onChangeImgUpload={onChangeImgUpload}
          gochiKidUseIdChoose={gochiKidUseId}
        />
      )}

      {showReceiptResultModal && (
        <GochiKidReceiptResultModal
          showing={showReceiptResultModal}
          onClose={handleCloseGochiKidResultModal}
          onSubmit={handleOpenGochiKidReceiptConfirmModal}
          gochiKidUseIdChoose={gochiKidUseId}
          receiptChoose={receiptChoose}
          itemReceiptArr={itemReceiptArr}
          setItemReceiptArr={setItemReceiptArr}
          receiptImageBase64={receiptImageBase64}
        />
      )}

      {showReceiptConfirmModal && (
        <GochiKidReceiptConfirmModal
          showing={showReceiptConfirmModal}
          onClose={handleCloseGochiKidReceiptConfirmModal}
          onSubmit={handleSubmitGochiKidReceipt}
        />
      )}

      {showReceiptSuccessModal && (
        <GochiKidReceiptSuccessModal
          showing={showReceiptSuccessModal}
          onClose={handleCloseReceiptSuccessModal}
          title={titleReceiptSuccessModal}
          message={messageReceiptSuccessModal}
        />
      )}

      {showErrorReceiptModal && (
        <GochiKidErrorUploadReceiptModal
          showing={showErrorReceiptModal}
          onClose={handleCloseErrorReceiptModal}
          message={messageErrorReceiptModal}
          onChangeImgUpload={onChangeImgUpload}
          gochiKidUseIdChoose={gochiKidUseId}
        />
      )}

      {showErrorModal && (
        <div
          className={
            showErrorModal
              ? "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal gochi-kid-upload-receipt-error gochi-kid-receipt-error show-modal"
              : "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal gochi-kid-upload-receipt-error gochi-kid-receipt-error"
          }
          size="sm"
        >
          <div
            className={
              showErrorModal
                ? "modal modal-action modal-dialog is-show history-modal"
                : "modal modal-action modal-dialog history-modal"
            }
          >
            <div className="modal-header-history">
              <button
                className="modal-btn modal-btn-close"
                id="modalClose"
                onClick={() => {
                  handleCloseErrorModal();
                }}
                type="button"
              >
                <svg className="icon">
                  <title>閉じる</title>
                  <use xlinkHref="/assets/img/common/icon.svg#times" />
                </svg>
              </button>
            </div>
            <div className="title-modal title-modal-charge">
              <div className="title required-dot">
                <div className="dot-red"></div>
                レシート登録 画像確認
              </div>
            </div>
            <div className={`modal-body`}>{messageErrorModal}</div>
            <div className="modal-footer">
              <button
                className="btn btn-rect btn-submit"
                onClick={() => {
                  handleCloseErrorModal();
                }}
              >
                前の画面に戻る
              </button>
            </div>
          </div>
          <div className={`back-drop`} />
        </div>
      )}

      {showReceiptDetailModal && (
        <TwoocaReceiptDetailModal
          showing={showReceiptDetailModal}
          onClose={() => setShowReceiptDetailModal(false)}
          receiptChoose={receiptChoose}
          receiptImageBase64={receiptImageBase64}
        />
      )}
    </>
  );
}
